import { useQuery } from "@tanstack/react-query";
import { adminSearchService } from "../../../services/adminSearch";
import { useAdminSearchStore } from "../store/adminSearchStore";

export function useAdminSearchSubscriptions() {
  const { subscriptionsState } = useAdminSearchStore();
  const { filters: subscriptionsFilters, pagination } = subscriptionsState;

  const queryKey = [
    "adminSearchSubscriptions_key",
    {
      userInput: subscriptionsFilters.userInput,
      autoRenewal: subscriptionsFilters.autoRenewal,
      freeTrialUsed: subscriptionsFilters.freeTrialUsed,
      startDate: subscriptionsFilters.startDate,
      endDate: subscriptionsFilters.endDate,
      lastUpdated: subscriptionsFilters.lastUpdated,
      subscriptionType: subscriptionsFilters.subscriptionType,
      page: pagination.page,
      limit: pagination.limit,
    },
  ];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const filters = {};

      if (subscriptionsFilters.userInput?.trim()) {
        filters.userInput = subscriptionsFilters.userInput.trim();
      }
      if (typeof subscriptionsFilters.autoRenewal === "boolean") {
        filters.autoRenewal = subscriptionsFilters.autoRenewal;
      }
      if (typeof subscriptionsFilters.freeTrialUsed === "boolean") {
        filters.freeTrialUsed = subscriptionsFilters.freeTrialUsed;
      }

      const addRange = (key, range) => {
        if (!range) return;
        const hasFrom = typeof range.from === "number";
        const hasTo = typeof range.to === "number";
        if (hasFrom || hasTo) {
          filters[key] = {
            ...(hasFrom ? { from: range.from } : {}),
            ...(hasTo ? { to: range.to } : {}),
          };
        }
      };

      addRange("startDate", subscriptionsFilters.startDate);
      addRange("endDate", subscriptionsFilters.endDate);
      addRange("lastUpdated", subscriptionsFilters.lastUpdated);

      if (
        Array.isArray(subscriptionsFilters.subscriptionType) &&
        subscriptionsFilters.subscriptionType.length > 0
      ) {
        filters.subscriptionType = subscriptionsFilters.subscriptionType;
      }

      const res = await adminSearchService.adminSearchSubscriptions({
        page: pagination.page,
        limit: pagination.limit,
        filters,
      });
      return {
        subscriptions: res.subscriptions || [],
        total: res.total || 0,
      };
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
